<div (dragover)="startUploadFiles()">
  <div class="filebrowser-loading-screen-overlay" *ngIf="isDownloading">
    <div><i class="fas fa-spinner fa-spin"></i></div>
  </div>

  <div class="file-browser-toolbar">
    <nb-form-field>
      <input
        nbInput
        [(ngModel)]="searchParam"
        [placeholder]="'search_files'| translation"
        (keydown.enter)="search(searchParam)"
        fullWidth
      />
      <i
        style="position: relative; right: 25px"
        class="fa-thin fa-magnifying-glass"
        (click)="search(searchParam)"
      ></i>

      <!-- <nb-icon
        status="primary"
        nbSuffix
        pack="fa-thin"
        icon="search"
        
      ></nb-icon> -->
    </nb-form-field>
    <div>
      <nb-button-group outline>
        <button nbButtonToggle [(pressed)]="tiles">
          <nb-icon pack="fas" icon="th"></nb-icon>
        </button>
        <button nbButtonToggle [(pressed)]="list">
          <nb-icon pack="fas" icon="bars"></nb-icon>
        </button>
      </nb-button-group>
    </div>
    <div>
      <label class="color-style-grey">{{'filter_by'| translation}}:</label>
      <nb-select
        [placeholder]="'filter_type'| translation"
        [(ngModel)]="typeFilter"
        [disabled]="filter"
        (selectedChange)="navigate(null, folder, true, true, false)"
      >
        <nb-option value="">{{'any'| translation}}</nb-option>
        <nb-option value="image">{{'image'| translation}}</nb-option>
        <nb-option value="doc">{{'document'| translation}}</nb-option>
        <nb-option value="pdf">{{'pdf'| translation}}</nb-option>
      </nb-select>
    </div>

    <div>
      <label class="color-style-grey">{{'paginate_items_per_page'| translation}}:</label>
      <nb-select
        [(ngModel)]="perPage"
        placeholder="Per Page"
        (selectedChange)="setPageCount($event)"
      >
        <nb-option
          *ngFor="let option of perPageOptions"
          [value]="option.count"
          >{{ option.count }}</nb-option
        >
      </nb-select>
    </div>

    <div style="flex: 1 1 auto"></div>
    <div *ngIf="allowupload && !isDisable()">
      <button nbButton (click)="startUploadFiles()">{{'upload_files'| translation}}</button>
      <button nbButton (click)="startCreateFolder()">{{'new_folder'| translation}}</button>
    </div>
  </div>
  <div *ngIf="terms.length">
    <p>{{'searching'| translation}}:</p>
    <nb-tag-list (tagRemove)="search(null)">
      <nb-tag *ngFor="let term of terms" [text]="term" removable></nb-tag>
    </nb-tag-list>
  </div>
  <div>
    <h2>{{'folders'| translation}}</h2>
  </div>
  <div class="file-folder-breadcrumbs" aria-label="file browser breadcrumbs">
    <span>
      <ng-container *ngIf="folder.get('route')?.length !== 0; else textview">
        <a (click)="navigate($event, basefolder)" href="#">
          {{ (scope === 'institution' ? ('global' | translation) : ('course' | translation)) }}

        </a>
      </ng-container>
      <ng-template #textview>
        <span class="color-style-grey">
          {{ (scope === 'institution' ? ('global' | translation) : ('course' | translation)) }}
        </span>
      </ng-template>
    </span>
    <span *ngFor="let fold of folder.get('route'); let i = index">
      <i
        class="fas fa-chevron-right"
        style="font-size: 10px; margin-right: 5px"
      ></i>

      <ng-container
        *ngIf="i !== folder.get('route')?.length - 1; else textview"
      >
        <a (click)="navigate($event, fold)" href="#">
          {{ fold.data.title }}
        </a>
      </ng-container>
      <ng-template #textview>
        <span class="color-style-grey">{{ fold.data.title }}</span>
      </ng-template>

      <!-- <a (click)="navigate($event, fold)" href="#">
        {{ fold.data.title }} </a
      > -->
    </span>
  </div>
  <div class="file-browser-content">
    <div *ngIf="creatingFolder && !readOnly">
      <nb-form-field>
        <input nbInput placeholder="Folder Name" [(ngModel)]="newFolderName" />
        <button
          nbButton
          ghost
          (click)="createFolder(newFolderName)"
          [disabled]="!newFolderName || newFolderName.length === 0"
        >
          <i class="fas fa-check"></i>
        </button>
        <button nbButton ghost (click)="cancelFolder()">
          <i class="fas fa-ban"></i>
        </button>
      </nb-form-field>
    </div>
    <div
      class="file-browser-main"
      [ngClass]="{ 'file-list': !tiles, 'file-tiles': tiles }"
    >
      <div *ngIf="isLoadingFolders; else foldersView">
        <div><i class="fas fa-spinner fa-spin"></i></div>
      </div>
      <ng-template #foldersView>
        <h6  *ngIf="!folder.get('folders')?.length; else displayFolders">
          {{'no_folders_to_display'| translation}}
        </h6>

        <ng-template #displayFolders>
          <app-file-display
            class="file-content-row"
            *ngFor="let item of folder.get('folders')"
            [ngClass]="{ 'filde-browser-selected': selectedFile === item }"
            (click)="navigate($event, item)"
            (keydown)="keydown($event, item)"
            role="button"
            [item]="item"
            [tiles]="tiles"
            tabindex="0"
            [isDisabled]="isDisable()"
            (settings)="openSettings($event)"
            (move)="openMove($event)"
            (delete)="delete($event)"
            (zip)="startZipFolder($event)"
          >
          </app-file-display>
        </ng-template>
      </ng-template>
    </div>
  </div>
  <scaffold-paginator
    *ngIf="totalFolderItems && perPage < totalFolderItems ||totalFolderItems===null"
    (activePageChange)="activePageChange($event, 'folder')"
    [itemCount]="totalFolderItems"
    [(activePage)]="currentFolderPage"
    [perPage]="perPage"
  ></scaffold-paginator>

  <div>
    <h2>
      {{'files'| translation}} <span *ngIf="filter">({{ filter }})</span>
    </h2>
  </div>

  <div class="file-browser-content">
    <div
      class="file-browser-main"
      [ngClass]="{ 'file-list': !tiles, 'file-tiles': tiles }"
    >
      <div *ngIf="isLoadingFiles; else filesView">
        <div><i class="fas fa-spinner fa-spin"></i></div>
      </div>
      <ng-template #filesView>
        <h6 *ngIf="!folder.get('files')?.length; else filesDisplay">
          {{'no_files_to_display'| translation}}
        </h6>
        <ng-template #filesDisplay>
          <app-file-display
            class="file-content-row"
            *ngFor="let item of folder.get('files'); trackBy: trackByIndex"
            [ngClass]="{
              'filde-browser-selected': selectedFile === item,
              'file-browser-allow-selection': allowSelection
            }"
            (click)="selectFileItem(item)"
            (keydown.enter)="selectFileItem(item)"
            (keydown.space)="selectFileItem(item)"
            [item]="item"
            [tiles]="tiles"
            [tabindex]="allowSelection ? 0 : -1"
            [isDisabled]="isDisable()"
            role="button"
            (settings)="openSettings($event)"
            (zip)="startZip($event)"
            (move)="openMove($event)"
            (delete)="delete($event)"
          >
          </app-file-display>
        </ng-template>
      </ng-template>
    </div>
  </div>
  <scaffold-paginator
    *ngIf="totalFileItems && perPage < totalFileItems"
    (activePageChange)="activePageChange($event, 'files')"
    [itemCount]="totalFileItems"
    [(activePage)]="currentFilePage"
    [perPage]="perPage"
  ></scaffold-paginator>

  <p *ngIf="courseFileSize">
    {{'course_file_storage'| translation}}: {{ courseFileSize | filesize }}
  </p>
</div>
